import React, { useState } from 'react';
import { About } from '../../pages/About/About.jsx';
import { BlancoDeCazador } from '../../pages/BlancoDeCazador/BlancoDeCazador.jsx';

import './AboutCompuesto.scss';

export const AboutCompuesto = () => {
	const [showAbout, setShowAbout] = useState(true);

	const toggleComponents = () => {
		setShowAbout(!showAbout);
	};

	return (
		<div className='AboutCompuesto'>
			{/* Botón para alternar la visibilidad, puede ser una flecha o un ícono */}
			<button onClick={toggleComponents} className='toggle-button'>
				{showAbout ? '➡️' : '⬅️'}
			</button>

			{/* Componente About */}
			<div
				className={`component-container ${
					showAbout ? 'visible' : 'hidden'
				}`}
			>
				<About />
			</div>

			{/* Componente BlancoDeCazador */}
			<div
				className={`component-container ${
					!showAbout ? 'visible' : 'hidden'
				}`}
			>
				<BlancoDeCazador />
			</div>
		</div>
	);
};
